import { render, staticRenderFns } from "./FormCaixa.vue?vue&type=template&id=964c93b0&scoped=true"
import script from "./FormCaixa.vue?vue&type=script&lang=js"
export * from "./FormCaixa.vue?vue&type=script&lang=js"
import style0 from "./FormCaixa.vue?vue&type=style&index=0&id=964c93b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c93b0",
  null
  
)

export default component.exports